import { IconShoppingCart } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconCart: FC<IconProps> = props => (
  <SvgIcon {...props} component={IconShoppingCart} />
)

export default IconCart
